export const SET_STATE_SIDES_NAV = "@@app/SET_STATE_SIDES_NAV";